
import { useMemo } from 'react';
import { useAdminActivity } from '@/hooks/useAdminActivity';
import { useAdminToast } from '@/hooks/admin/useAdminToast';

/**
 * Hook for managing admin activity in the admin page
 */
export const useAdminPageActivity = () => {
  const { 
    adminActions, 
    adminState, 
    recordAction, 
    removeActiveAdmin, 
    refreshAdminData,
    isLoading: activityLoading,
    isActionThrottled,
    usingSupabase: activityUsingSupabase
  } = useAdminActivity(240000); // 4 minutes polling (increased from 30 seconds)
  
  // Use toast hook for throttled actions
  useAdminToast(isActionThrottled);
  
  return {
    adminActions,
    adminState,
    recordAction,
    removeActiveAdmin,
    refreshAdminData,
    isLoading: activityLoading,
    isActionThrottled,
    usingSupabase: activityUsingSupabase
  };
};
